import { jsx } from "react/jsx-runtime";
import { useRef, useState, useEffect } from "react";
const ScrubberSlider = ({
  defaultValue,
  onChange,
  id,
  chartHeight
}) => {
  const canvasRef = useRef(null);
  const onChangeRef = useRef(onChange);
  const sliderInitialized = useRef(false);
  const [linePosition, setLinePosition] = useState(defaultValue);
  const [sliderPosition, setSliderPosition] = useState(0);
  const [containerWidth, setContainerWidth] = useState({
    width: 0
  });
  const minValue = 0;
  const maxValue = 30;
  const lineColor = "rgba(0, 0, 0, 0.5)";
  const sliderColor = "#fff";
  const handleFillColor = "white";
  const handleBorderColor = "#d3d3d3";
  const sliderRadius = 9;
  const handleRadius = 9;
  const padding = 15;
  useEffect(() => {
    onChangeRef.current = onChange;
  }, [onChange]);
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    if (!ctx) return;
    const canvasWidth = canvas.clientWidth;
    const canvasHeight = canvas.clientHeight;
    canvas.width = canvasWidth;
    canvas.height = canvasHeight;
    const yearToPixel = (year) => padding + (year - 1 - minValue) / (maxValue - minValue) * (canvasWidth - 2 * padding);
    if (!sliderInitialized.current && canvasWidth > 0) {
      sliderInitialized.current = true;
      setSliderPosition(Math.max(padding, Math.min(yearToPixel(defaultValue), canvasWidth - padding)));
      return;
    }
    const drawSliderScrubber = () => {
      const dottedLineHeight = canvasHeight * 0.9;
      ctx.beginPath();
      ctx.setLineDash([4, 4]);
      ctx.moveTo(sliderPosition, canvasHeight - dottedLineHeight);
      ctx.lineTo(sliderPosition, canvasHeight);
      ctx.strokeStyle = lineColor;
      ctx.stroke();
      const numSteps = 30;
      const stepSize = (canvas.width - padding * 2) / numSteps;
      for (let i = 0; i <= numSteps; i += 1) {
        const xPos = padding + stepSize * i;
        ctx.beginPath();
        ctx.moveTo(xPos, canvas.height - sliderRadius);
        ctx.lineTo(xPos, canvas.height - sliderRadius - 0.1);
        ctx.strokeStyle = lineColor;
        ctx.stroke();
      }
      const mobileHandlePosition = canvas.height >= 145 ? 5 : 0;
      ctx.fillStyle = sliderColor;
      ctx.fill();
      ctx.strokeStyle = handleBorderColor;
      ctx.lineWidth = 2;
      ctx.stroke();
      ctx.beginPath();
      ctx.arc(sliderPosition, canvasHeight - sliderRadius - mobileHandlePosition, sliderRadius, 0, 2 * Math.PI);
      ctx.beginPath();
      ctx.arc(sliderPosition, canvasHeight - sliderRadius - mobileHandlePosition, handleRadius, 0, 2 * Math.PI);
      ctx.fillStyle = handleFillColor;
      ctx.fill();
      ctx.strokeStyle = handleBorderColor;
      ctx.lineWidth = 2;
      ctx.stroke();
    };
    const handleSliderMove = (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (event.buttons === 1) {
        const canvasRect = canvas.getBoundingClientRect();
        const canvasX = event.clientX - canvasRect.left;
        const sliderPositionWithPadding = Math.min(Math.max(padding, canvasX), canvasWidth - padding);
        const sliderValue = Math.round((sliderPositionWithPadding - padding) / (canvasWidth - 2 * padding) * (maxValue - minValue) + minValue) + 1;
        const stepIndex = Math.min(maxValue, Math.max(minValue, sliderValue));
        setLinePosition((prev) => isNaN(stepIndex) ? prev : stepIndex);
        const updatedSliderPosition = Math.min(sliderPositionWithPadding, canvasWidth - padding);
        setSliderPosition(updatedSliderPosition);
        if (isNaN(stepIndex)) return;
        onChangeRef.current(stepIndex);
      }
    };
    const handleTouchMove = (event) => {
      var _a, _b;
      event.preventDefault();
      const touchX = ((_b = (_a = event.touches) == null ? void 0 : _a[0]) == null ? void 0 : _b.clientX) - canvas.getBoundingClientRect().left;
      const sliderPositionWithPadding = Math.min(Math.max(padding, touchX), containerWidth.width - padding);
      const sliderValue = Math.round((sliderPositionWithPadding - padding) / (canvasWidth - 2 * padding) * (maxValue - minValue) + minValue) + 1;
      const stepIndex = Math.min(sliderValue, maxValue);
      setLinePosition((prev) => isNaN(stepIndex) ? prev : stepIndex);
      const updatedSliderPosition = Math.min(sliderPositionWithPadding, canvasWidth - padding);
      setSliderPosition((prev) => isNaN(updatedSliderPosition) ? prev : updatedSliderPosition);
      if (isNaN(stepIndex)) return;
      onChangeRef.current(stepIndex);
    };
    canvas.addEventListener("mousemove", handleSliderMove);
    canvas.addEventListener("mouseup", handleSliderMove);
    canvas.addEventListener("touchmove", handleTouchMove);
    canvas.addEventListener("touchend", handleTouchMove);
    drawSliderScrubber();
    return () => {
      canvas.removeEventListener("mousemove", handleSliderMove);
      canvas.removeEventListener("mouseup", handleSliderMove);
      canvas.removeEventListener("touchmove", handleTouchMove);
      canvas.removeEventListener("touchend", handleTouchMove);
    };
  }, [containerWidth, linePosition, sliderPosition, defaultValue]);
  useEffect(() => {
    var _a;
    const resizeObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        const {
          width
        } = entry.contentRect;
        setContainerWidth({
          width
        });
      });
    });
    const parentContainer = (_a = canvasRef.current) == null ? void 0 : _a.parentNode;
    if (!parentContainer) return;
    resizeObserver.observe(parentContainer);
    return () => {
      resizeObserver.unobserve(parentContainer);
    };
  }, []);
  return /* @__PURE__ */ jsx("canvas", { ref: canvasRef, style: {
    width: "100%",
    height: chartHeight ? `${chartHeight}px` : "100%",
    display: "block"
  }, id });
};
export {
  ScrubberSlider as default
};
